<template>
  <MenuCard title="Transform" tooltip="Transform your model to change how it looks">
      <v-card-text class="">
        <div>
          <Row title="Scale">
          <NumberController width="50" v-model="scaleX"> </NumberController>
          <NumberController width="50" v-model="scaleY"> </NumberController>
          <NumberController width="50" v-model="scaleZ"> </NumberController>
          </Row>
          <Row title="Rotation">
          <NumberController width="50" v-model="rotationX"> </NumberController>
          <NumberController width="50" v-model="rotationY"> </NumberController>
          <NumberController width="50" v-model="rotationZ"> </NumberController>
          </Row>
          <!-- <v-text-field step=0.1 hide-details class="mb-2" min=0 label="X" type='number' v-model.number:value="x"></v-text-field>
          <v-text-field step=0.1 hide-details class="mb-2" min=0 label="Y" type='number' v-model.number:value="y"></v-text-field>
          <v-text-field step=0.1 hide-details class="mb-2" min=0 label="Z" type='number' v-model.number:value="z"></v-text-field> -->
        </div>
      </v-card-text>
  </MenuCard>
</template>

<script>
import MenuCard from './MenuCard.vue'
import Row from './Row.vue'
import NumberController from './NumberController.vue'

  export default {
    name: 'TransformMenu',
    components: {
        MenuCard,
        Row,
        NumberController,
    },
    methods: {
        updateTransformSettings() {
            this.transformSettings = {scaleX: this.scaleX,
                                      scaleY: this.scaleY,
                                      scaleZ: this.scaleZ,
                                      rotationX: this.rotationX,
                                      rotationY: this.rotationY,
                                      rotationZ: this.rotationZ,
                                        };
        },
    },
    
    mounted() {
        this.scaleX = this.transformSettings.scaleSettings.x;
        this.scaleY = this.transformSettings.scaleSettings.y;
        this.scaleZ = this.transformSettings.scaleSettings.z;

        this.rotationX = this.transformSettings.rotationSettings.x;
        this.rotationY = this.transformSettings.rotationSettings.y;
        this.rotationZ = this.transformSettings.rotationSettings.z;
    },

    data: function () {
        //return { x: this.scaleSettings.x, y: this.scaleSettings.y, z: this.scaleSettings.z};
        return { scaleX: 1, scaleY: 1, scaleZ: 1,
                 rotationX: 0, rotationY: 0, rotationZ: 0,
               };
    },

    props: [],
    watch: {
        scaleX: function() {
            this.updateTransformSettings();
        },
        scaleY: function() {
            this.updateTransformSettings();
        },
        scaleZ: function() {
            this.updateTransformSettings();
        },
        rotationX: function() {
            this.updateTransformSettings();
        },
        rotationY: function() {
            this.updateTransformSettings();
        },
        rotationZ: function() {
            this.updateTransformSettings();
        },
    },

    computed: {
        transformSettings: {
            get() {
                return {...this.$store.state.transformSettings};
            },
            set(value) {
                this.$store.commit('setTransformSettings', value);
            },
        },
    },
  }
</script>


